export default __webpack_public_path__ + "static/warning-graphic-54a6993872f80f06aa7c4c29459caded.svg";